import { gql } from "@apollo/client";

export default gql`
  query getUserAssessmentDeliveries(
    $targetId: Int!
    $excludedProgramIds: [Int!]
  ) {
    assessmentDeliveries(
      targetId: $targetId
      excludedProgramIds: $excludedProgramIds
    ) {
      edges {
        node {
          id
          complianceProgram {
            id
            title
            startDate
            dueDate
          }
        }
      }
    }
  }
`;
